import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type SignedDocumentRequest = {
  documentId: number;
  token: string;
};

const signedDocument = async ({ documentId, token }: SignedDocumentRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/sign-document`,
      { documentId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default signedDocument;
